
import { Vue, Component, Mixins, Ref, Prop } from "vue-property-decorator";

import VModal from "@monade/vue-components/src/components/VModal.vue";
import { RegisterHttp } from "@/utils/Decorators";
import RequestData from "@/store/types/RequestData";
import { safeAsync } from "@/utils/AsyncUtil";
import { showErrorToast, showToast } from "@/utils/Toast";
import OrganizationMixin, {
  OrganizationTags,
} from "@/mixins/http/OrganizationMixin";

@Component({
  components: {
    VModal,
  },
})
export default class OrganizationContactModal extends Mixins(
  OrganizationMixin
) {
  @Ref() readonly modal!: VModal;

  private organizationId = "";
  private message = "";

  @RegisterHttp(OrganizationTags.OrganizationContact)
  readonly contactOwnerRequest!: RequestData;

  show(organizationId: string) {
    this.organizationId = organizationId;
    this.modal.show();
  }

  hide() {
    this.modal.hide();
  }

  get loading() {
    return this.contactOwnerRequest?.loading;
  }

  private async sendEmail() {
    const [data, errors] = await safeAsync(
      this.contactOrganization(this.organizationId, this.message)
    );

    if (errors) {
      showErrorToast("Errore durante l'invio dell'email");
      return;
    }

    showToast("Email inviata con successo!");
    this.hide();
  }
}
